import { LoyaltyType } from "./loyalty-type.enum";
import { LoyaltyStatus } from "./loyalty-status.model";

export class MarketplaceState extends LoyaltyStatus{

    constructor(o?: Partial<MarketplaceState>){
        o = o || {};
        super(o);
        this.type = LoyaltyType.MARKETPLACE;
    }
}